import React from "react";
import styles from "./LeaderPPVModal.module.scss";
import { useAppSelector } from "../../../redux/hooks";
import Icon from "../../common/Icon/Icon";
import { useProfileParams } from "../../../utils/common";
import MyAccountsLoader from "../../common/Loaders/MyAccountsLoader/MyAccountsLoader";
import { useTranslation } from "react-i18next";
import {
  FormatLocalizedNumber,
} from "../../../utils/NumberFormatter";

interface LeaderPPVProps {
  data: LeaderData[];
  isLoading: boolean;
  isError: boolean;
}

interface LeaderData {
  affiliateCode: string;
  aboNumber: string;
  name: string;
  localName: string;
  cpv: number;
  vcs: number;
  personalPv: {
    kpiValue: string;
    kpiFlagCode: string;
    kpiFlagName: string;
  };
}

const LeaderPPVModal: React.FC<LeaderPPVProps> = ({data, isLoading, isError}) => {
  const userAffiliateCode = useAppSelector((state: any) => state.userDetails.user)?.userAffiliateCode || 0;
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const { affiliateCode } = useProfileParams();
  const { t } = useTranslation();
  const renderFlag = (kpiFlagCode?: string) => {
    if (kpiFlagCode === "3") {
      return (
        <span className={styles.flag_red}>
          <Icon
            name="flag"
            size={14}
            color={currentTheme === "light" ? "#D91734" : "#F16A81"}
            className={styles.flag}
          />
        </span>
      );
    }
    if (kpiFlagCode === "2") {
      return (
        <span className={styles.flag_yellow}>
          <Icon
            name="flag"
            size={14}
            color={currentTheme === "light" ? "#DA7600" : "#FED773"}
            className={styles.flag}
          />
        </span>
      );
    }
    return null;
  };
  if(isLoading) {
    return <div className={styles.ppv_loader}>
        <MyAccountsLoader num={4} hideCustomViewPanel={true} />
      </div>
  }
  if(!isLoading && !isError && data.length === 0) {
    return <div className={styles.empty_state_document}>
      <div className={`table_no_data ${styles.empty_state_msg}`}>
        {t("noAboAvailable")}
      </div>
    </div>
  }
  return (
    <div
      className={`leader_details_ppv_modal ${styles.leader_details_ppv_modal}`}
    >
      <div className={`inner_wrapper ${styles.inner_wrapper}`}>
        <div className={`modal_title ${styles.modal_title}`}>
          {t("group_leader_ppv")}
        </div>
        <div className={`leader_table ${styles.leader_table}`}>
          <div className={`header_wrapper ${styles.header_wrapper}`}>
            <div className={`header_cell ${styles.header_cell}`}>{t("award_milstone")}</div>
            <div className={`header_cell ${styles.header_cell}`}>{t("performance_table.labels.ppv")}</div>
            <div className={`header_cell ${styles.header_cell}`}>{affiliateCode === "010" ? t("vcs") : t("cpv")}</div>
          </div>
          <div className={styles.row_wrapper}>
            {data.map((entry: LeaderData, index: number) => (
              <div className={`row_info ${styles.row_info}`} key={index}>
                <div className={`row_data_cell ${styles.data_cell}`}>
                  <span className={styles.rank}>#{index+1}</span>{" "}
                  {entry.name} (ABO {entry.aboNumber})
                </div>
                <div className={`row_data_cell ${styles.data_cell}`}>
                  {FormatLocalizedNumber(userAffiliateCode, entry.personalPv.kpiValue)} {renderFlag(entry.personalPv.kpiFlagCode)}
                </div>
                <div className={`row_data_cell ${styles.data_cell}`}>
                  {affiliateCode === "010" ? FormatLocalizedNumber(userAffiliateCode, entry.vcs) : FormatLocalizedNumber(affiliateCode, entry.cpv)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderPPVModal;
